module.exports = __webpack_public_path__ + "img/adulto31.077fbccb.jpg";